module.exports = "/_next/static/images/dragon-94775408056f3b0aa5577c4d93913845.png";